import { Config } from "../../utils/config";
import {
  AuthConfig,
  EnvironmentConfig,
  EnvironmentName,
} from "./company.types";

export const getCompanyEnvironmentConfig: (
  companyConfigs: EnvironmentConfig
) => AuthConfig = (companyConfigs) => {
  return companyConfigs[Config.Environment.toLowerCase() as EnvironmentName];
};

export const TriumphContactUrl = "http://triumph.io/";
